const OLD_GRADE_ID: Record<string, number> = {
  'ابتدایی-پایه-اول': 13,
  'ابتدایی-پایه-دوم': 14,
  'ابتدایی-پایه-سوم': 15,
  'ابتدایی-پایه-چهارم': 16,
  'ابتدایی-پایه-پنجم': 17,
  'ابتدایی-پایه-ششم': 18,
  'متوسطه-اول-پایه-هفتم': 19,
  'متوسطه-اول-پایه-هشتم': 20,
  'متوسطه-اول-پایه-نهم': 21,
  'متوسطه-دوم-پایه-دهم-ریاضی-فیزیک': 22,
  'متوسطه-دوم-پایه-دهم-علوم-انسانی': 23,
  'متوسطه-دوم-پایه-دهم-علوم-تجربی': 24,
  'متوسطه-دوم-پایه-یازدهم-ریاضی-فیزیک': 25,
  'متوسطه-دوم-پایه-یازدهم-علوم-انسانی': 26,
  'متوسطه-دوم-پایه-یازدهم-علوم-تجربی': 27,
  'متوسطه-دوم-پایه-دوازدهم-ریاضی-فیزیک': 28,
  'متوسطه-دوم-پایه-دوازدهم-علوم-انسانی': 29,
  'متوسطه-دوم-پایه-دوازدهم-علوم-تجربی': 30,
  'کنکور-پایه-دهم-ریاضی-فیزیک': 38,
  'کنکور-پایه-دهم-علوم-انسانی': 39,
  'کنکور-پایه-دهم-علوم-تجربی': 40,
  'کنکور-پایه-یازدهم-ریاضی-فیزیک': 41,
  'کنکور-پایه-یازدهم-علوم-انسانی': 42,
  'کنکور-پایه-یازدهم-علوم-تجربی': 43,
  'کنکور-پایه-دوازدهم-ریاضی-فیزیک': 44,
  'کنکور-پایه-دوازدهم-علوم-انسانی': 45,
  'کنکور-پایه-دوازدهم-علوم-تجربی': 46,
  'تیزهوشان-پایه-ششم': 51,
  'تیزهوشان-پایه-نهم': 52,
  'کنکور-پایه-دوازدهم-هنر': 53,
  'کنکور-پایه-دوازدهم-فرهنگیان': 54,
  'امتحان-نهایی-پایه-دهم-ریاضی-فیزیک': 59,
  'امتحان-نهایی-پایه-دهم-علوم-انسانی': 60,
  'امتحان-نهایی-پایه-دهم-علوم-تجربی': 61,
  'امتحان-نهایی-پایه-یازدهم-ریاضی-فیزیک': 62,
  'امتحان-نهایی-پایه-یازدهم-علوم-انسانی': 63,
  'امتحان-نهایی-پایه-یازدهم-علوم-تجربی': 64,
  'امتحان-نهایی-پایه-دوازدهم-ریاضی-فیزیک': 65,
  'امتحان-نهایی-پایه-دوازدهم-علوم-انسانی': 66,
  'امتحان-نهایی-پایه-دوازدهم-علوم-تجربی': 67,
  'امتحانات-پایه-اول': 10062,
  'امتحانات-پایه-دوم': 10063,
  'امتحانات-پایه-سوم': 10064,
  'امتحانات-پایه-چهارم': 10065,
  'امتحانات-پایه-پنجم': 10066,
  'امتحانات-پایه-ششم': 10067,
  'امتحانات-پایه-هفتم': 10068,
  'امتحانات-پایه-هشتم': 10069,
  'امتحانات-پایه-نهم': 10070,
};

export default OLD_GRADE_ID;
